import { useMemo } from 'react';

// Base z-index must be higher than overlays like Shippy sidebar (1060)
const BASE_Z_INDEX = 1070;
// If we exceed this value on the initial calculation for whatever reason, cap it here
const MAX_Z_INDEX = 1000000000;

let currentMaxZ;

export const getMaxZ = (incrementBy = 1) => {
  if (!currentMaxZ) {
    const nodes = document.querySelectorAll('*');

    currentMaxZ = Array.prototype.reduce.call(
      nodes,
      (maxZ, node) => {
        const { zIndex } = window.getComputedStyle(node);
        if (zIndex !== 'auto' && !Number.isNaN(zIndex) && Number(zIndex) > maxZ) {
          return Math.min(Number(zIndex), MAX_Z_INDEX);
        }
        return maxZ;
      },
      BASE_Z_INDEX,
    );
  }

  currentMaxZ += incrementBy;

  return currentMaxZ;
};

export const useMaxZ = () => useMemo(getMaxZ, []);
